<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li v-if="rowData.regiao_uf.length > 0" class="nav-item">
          <a
            v-bind:class="{ active: rowData.regiao_uf.length > 0 }"
            class="nav-link active"
            v-bind:href="'#t1' + rowData.regiao_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              UFs
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li v-if="rowData.regiao_municipio.length > 0" class="nav-item">
          <a
            v-bind:class="{ active: rowData.regiao_uf.length == 0 }"
            class="nav-link"
            v-bind:href="'#t2' + rowData.regiao_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              Municípios
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
        <li v-if="rowData.regiao_cep.length > 0" class="nav-item">
          <a
            v-bind:class="{ active: rowData.regiao_cep.length == 0 }"
            class="nav-link"
            v-bind:href="'#t3' + rowData.regiao_id + ''"
            role="tab"
            data-toggle="tab"
          >
            <span class="nav-link-in">
              CEP
              <i class="fa fa-plus"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div
          v-bind:class="{
            active: rowData.regiao_uf.length > 0,
            show: rowData.regiao_uf.length > 0,
          }"
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t1' + rowData.regiao_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 30%">UF</th>
                <th style="width: 20%">Status</th>
                <th style="width: 20%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.regiao_uf"
              >
                <td>{{ item.uf.cd }} - {{ item.uf.nome }}</td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
                <td>
                  <a @click="onEditUf(item)" v-b-tooltip title="Editar"
                    ><i class="fa fa-pencil-square-o"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          v-bind:class="{
            active: rowData.regiao_uf.length == 0,
            show: rowData.regiao_uf.length == 0,
          }"
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t2' + rowData.regiao_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 30%">Município</th>
                <th style="width: 20%">Status</th>
                <th style="width: 20%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.regiao_municipio"
              >
                <td>
                  {{ item.municipio.nome + " - " + item.municipio.uf.cd }}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
                <td>
                  <a @click="onEditMunicipio(item)" v-b-tooltip title="Editar"
                    ><i class="fa fa-pencil-square-o"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
        <div
          v-bind:class="{
            active: rowData.regiao_cep.length == 0,
            show: rowData.regiao_cep.length == 0,
          }"
          role="tabpanel"
          class="tab-pane fade pt-1 border-color-detalhes-grey"
          v-bind:id="'t3' + rowData.regiao_id + ''"
        >
          <table class="table" id="mais">
            <thead>
              <tr>
                <th style="width: 30%">CEP Inicial</th>
                <th style="width: 20%">CEP Final</th>
                <th style="width: 20%">Municipio</th>
                <th style="width: 20%">Status</th>
                <th style="width: 10%">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="bg-gray-light"
                style="display: table-row"
                v-for="item in rowData.regiao_cep"
              >
                <td>
                  {{ item.cep_ini }}
                </td>
                <td>
                  {{ item.cep_fim }}
                </td>
                <td>
                  {{ item.municipio.nome + " - " +  item.municipio.uf.cd}}
                </td>
                <td>
                  <span
                    class="badge badge-success"
                    v-if="item.status.valor == 1"
                    >{{ item.status.descr }}</span
                  >
                  <span
                    class="badge badge-danger"
                    v-if="item.status.valor == 2"
                    >{{ item.status.descr }}</span
                  >
                </td>
                <td>
                  <a
                    v-if="item.status.valor == 2"
                    @click="
                      onActivateDesactivateCep(1, item, true)
                    "
                    v-b-tooltip
                    title="Ativar"
                    ><i class="fa fa-thumbs-o-up"></i
                  ></a>
                  <a
                    v-if="item.status.valor == 1"
                    @click="
                      onActivateDesactivateCep(2, item, true)
                    "
                    v-b-tooltip
                    title="Inativar"
                    ><i class="fa fa-thumbs-o-down"></i
                  ></a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--.tab-pane-->
      </div>
      <!--.tab-content-->

      <RegiaoUfForm ref="regiaoufform" :rota="'regiao'" />
      <RegiaoCepForm ref="regiaocepform" :rota="'regiao'" />
      <RegiaoMunicipioForm ref="regiaomunicipioform" :rota="'regiao'" />
    </div>
  </div>
</template>

  <script>
import RegiaoUfForm from "../views/RegiaoUfForm.vue";
import RegiaoCepForm from "../views/RegiaoCepForm.vue";
import RegiaoMunicipioForm from "../views/RegiaoMunicipioForm.vue";
export default {
  components: {
    RegiaoUfForm,
    RegiaoCepForm,
    RegiaoMunicipioForm
  },

  data() {
    return {
      helpForm: new Form({ statusRecord: [], params: [], status: "" })
    };
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    onActivateDesactivateCep(action, data, tipo) {
      // Tipo = true = Checkbox
      this.helpForm.status = action;
      if (tipo) {
        this.helpForm.statusRecord = [];
        this.helpForm.statusRecord.push(data.regcep_id);
      } else {
        this.helpForm.statusRecord = [];
        this.$refs.vuetable.selectedTo.forEach((obj) => {
          this.helpForm.statusRecord.push({ id: obj, status: action });
        });
      }
      this.$refs.regiaocepform.onActivateDesactivate(this.helpForm);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    onEditUf(data) {
      this.$refs.regiaoufform.onEdit(data);
    },
    onEditMunicipio(data) {
      this.$refs.regiaomunicipioform.onEdit(data);
    }
  }
};
</script>
